// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: center;
  width: 100%;
}

.icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.MuiTypography-root.title {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 0.5rem;
  color: #E9E8F2;
}

.MuiTypography-root.description {
  font-size: 14px;
  font-weight: 400;
  color: #898892;
  margin-bottom: 2rem;
}

.MuiButtonBase-root.trainButton {
  background-color: #69319D;
  color: #fff;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  border-radius: 10px;
  text-transform: none;
  transition: background-color 0.3s;
}

.trainButton:hover {
  background-color: #5533cc;
}

/* Dialogue content root */
.MuiDialogContent-root .textBox {
  max-width: 100%;
  color: #ECEBF3;
  /* padding: 16px; */
  border-radius: 8px;
  background-color: #2D3055;
  font-size: 15px;
  font-weight: 400;
  font-family: var(--font-family-primary);

  @media screen and (min-width: 1024px) {
    max-width: 35%;
  }
}


.MuiDialogContent-root .dialogImage {
  max-width: 60%;
  height: auto;
}

.MuiDialogContent-root.dialogContent {
  display: flex;
  justify-content: center;
  align-items: start;
  gap: 16px;
  flex-direction: column;
  max-width: 100%;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
}

.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.closeButton {
  position: absolute;
  right: 0px;
  top: 8px;
  color: #000;
}



.MuiDialog-root.dialogContainer .MuiDialog-container .MuiPaper-root {
  max-width: 1000px;
}
.generateImageCardContainer{
  height: calc(100dvh - 200px);
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/GenerateImageCard/GenerateImageCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;;EAEvC;IACE,cAAc;EAChB;AACF;;;AAGA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,eAAe;;EAEf;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;;;;AAIA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  text-align: center;\n  width: 100%;\n}\n\n.icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n}\n\n.MuiTypography-root.title {\n  font-size: 18px;\n  font-weight: 400;\n  margin-bottom: 0.5rem;\n  color: #E9E8F2;\n}\n\n.MuiTypography-root.description {\n  font-size: 14px;\n  font-weight: 400;\n  color: #898892;\n  margin-bottom: 2rem;\n}\n\n.MuiButtonBase-root.trainButton {\n  background-color: #69319D;\n  color: #fff;\n  padding: 0.5rem 1.5rem;\n  font-size: 1rem;\n  border-radius: 10px;\n  text-transform: none;\n  transition: background-color 0.3s;\n}\n\n.trainButton:hover {\n  background-color: #5533cc;\n}\n\n/* Dialogue content root */\n.MuiDialogContent-root .textBox {\n  max-width: 100%;\n  color: #ECEBF3;\n  /* padding: 16px; */\n  border-radius: 8px;\n  background-color: #2D3055;\n  font-size: 15px;\n  font-weight: 400;\n  font-family: var(--font-family-primary);\n\n  @media screen and (min-width: 1024px) {\n    max-width: 35%;\n  }\n}\n\n\n.MuiDialogContent-root .dialogImage {\n  max-width: 60%;\n  height: auto;\n}\n\n.MuiDialogContent-root.dialogContent {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  gap: 16px;\n  flex-direction: column;\n  max-width: 100%;\n\n  @media screen and (min-width: 768px) {\n    flex-direction: row;\n  }\n}\n\n.MuiButtonBase-root.MuiIconButton-root.MuiIconButton-sizeMedium.closeButton {\n  position: absolute;\n  right: 0px;\n  top: 8px;\n  color: #000;\n}\n\n\n\n.MuiDialog-root.dialogContainer .MuiDialog-container .MuiPaper-root {\n  max-width: 1000px;\n}\n.generateImageCardContainer{\n  height: calc(100dvh - 200px);\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
